import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Loader2, ArrowLeft, LogIn } from "lucide-react";

export default function LoginHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/login-history").then((r) => setRows(r.data)).catch((e) => toast.error(apiError(e.response?.data?.detail))).finally(() => setLoading(false));
  }, []);
  return (
    <div className="space-y-6" data-testid="login-history-page">
      <div>
        <NavLink to="/users" className="mb-1 inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700"><ArrowLeft className="h-4 w-4" />Back to users</NavLink>
        <h2 className="flex items-center gap-2 font-heading text-2xl font-bold tracking-tight text-slate-900"><LogIn className="h-6 w-6 text-indigo-600" />Login History</h2>
        <p className="mt-1 text-sm text-slate-500">Recent sign-in activity across all accounts.</p>
      </div>
      <Card className="p-4">
        {loading ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-indigo-600" /></div> : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader><TableRow className="bg-slate-50"><TableHead className="text-xs uppercase text-slate-500">User</TableHead><TableHead className="text-xs uppercase text-slate-500">Email</TableHead><TableHead className="text-xs uppercase text-slate-500">When</TableHead></TableRow></TableHeader>
              <TableBody>
                {rows.map((l) => (
                  <TableRow key={l.id} data-testid={`login-row-${l.id}`}>
                    <TableCell className="font-medium text-slate-800">{l.actor_name || "—"}</TableCell>
                    <TableCell className="text-slate-600">{l.actor_email}</TableCell>
                    <TableCell className="text-slate-500">{new Date(l.timestamp).toLocaleString("en-IN")}</TableCell>
                  </TableRow>
                ))}
                {rows.length === 0 && <TableRow><TableCell colSpan={3} className="py-12 text-center text-slate-400">No login history.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
}
